import { TFunction } from 'i18next';
import * as Yup from 'yup';

// Alt-address fields are required only when "Alternative shipping address" is on.
const altAddressField = (t: TFunction, message: string) =>
  Yup.string().when('hasAlternativeShippingAddress', {
    is: true,
    then: (schema) => schema.required(t(message)),
    otherwise: (schema) => schema.optional(),
  });

export const quotationDetailsSchema = (t: TFunction) =>
  Yup.object().shape({
    // Customer
    first_name: Yup.string().required(t('First name is required')),
    last_name: Yup.string().required(t('Last name is required')),
    title: Yup.string().required(t('Title is required')),
    email: Yup.string()
      .email(t('Invalid email'))
      .required(t('Email is required')),
    phone: Yup.string().optional(),
    // Address
    country: Yup.string().required(t('Country is required')),
    zip_code: Yup.string().required(t('Zip code is required')),
    house_number: Yup.string().optional(),
    city: Yup.string().required(t('City is required')),
    street: Yup.string().required(t('Street is required')),
    // Company (optional)
    company_name: Yup.string().optional(),
    vat_number: Yup.string().optional(),
    // Quotation
    reference: Yup.string().required(t('Reference is required')),
    days_valid: Yup.string().optional(),
    // Alternative shipping address
    hasAlternativeShippingAddress: Yup.boolean(),
    alt_country: altAddressField(t, 'Country is required'),
    alt_zip_code: altAddressField(t, 'Zip code is required'),
    alt_house_number: Yup.string().optional(),
    alt_city: altAddressField(t, 'City is required'),
    alt_street: altAddressField(t, 'Street is required'),
  });
